// PR-A4 / H9 — allow-list-based `href` guard for the tenant-runtime
// SPA. Renders attacker-controlled urls smuggled into a Craft.js
// `props.link.url` / `props.social.url` as inert `#` rather than
// firing whatever the browser would do with `javascript:` /
// `data:` / `vbscript:`.
//
// Same allow-list as main-frontend's html-paste-sanitiser
// (http / https / mailto / tel) — kept in lockstep by convention,
// not by import, since runtime is built as a separate bundle and
// can't reach across repo boundaries cheaply.
const ALLOWED_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);

/**
 * Returns the url itself if its protocol is in the allow-list, or
 * the `fallback` (default `"#"`) otherwise. Renders an inert anchor
 * for any url that's null / unparseable / uses a banned protocol.
 *
 * The parse uses `https://placeholder.com` as the base so a relative
 * path like `/privacy` resolves and inherits the safe `https:` proto,
 * matching the legacy raw `href={url}` behaviour for relative urls.
 */
export function safeHref(url: string | null | undefined, fallback: string = "#"): string {
  if (!url) return fallback;
  try {
    const parsed = new URL(url, "https://placeholder.com");
    return ALLOWED_PROTOCOLS.has(parsed.protocol) ? url : fallback;
  } catch {
    return fallback;
  }
}
